import React from "react";
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';
import { Drawer } from '@material-ui/core';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse
} from '@material-ui/core';
import { NavLink, matchPath } from "react-router-dom";

import StorefrontIcon from '@material-ui/icons/Storefront';
import PeopleIcon from '@material-ui/icons/People';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import BusinessIcon from '@material-ui/icons/Business';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import LanguageIcon from '@material-ui/icons/Language';
import CardTravelIcon from '@material-ui/icons/CardTravel';
import HelpIcon from '@material-ui/icons/Help';
import EmailIcon from '@material-ui/icons/Email';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import DashboardIcon from '@material-ui/icons/Dashboard';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import I18n from "../../base/i18n.js";

import LoadMenuItemsUseCase from "../../use_cases/admin/load_menu_items_use_case.js";

import Routes from "../routes.js";

import { TopBarHeight, LeftMenuWidth } from "../constants.js";

const styles = theme => ({
  drawer: {
    width: LeftMenuWidth,
    marginTop: TopBarHeight,
    height: 'calc(100% - 50px)'
  },
  nestedListItem: {
    paddingLeft: "40px"
  },
  link: {
    padding: '0px',
    width: '100%',
    textDecoration: "none",
    textTransform: "none",
    fontSize: "18px",
    color: theme.palette.black,
    backgroundColor: "transparent",
    boxShadow: "none",
    display: "flex",
    "& .MuiButton-label": {
      display: "flex",
      justifyContent: 'flex-start',
      color: theme.palette.black,
      alignItems: "center",
    }
  },
  iconContainer: {
    minWidth: "42px"
  },
  icon: {
    color: theme.palette.black,
    marginRight: "15px",
    width: "22px",
    height: "22px",
  },
  textContainer: {
    marginTop: "0px",
    marginBottom: "0px"
  },
  activeLink: {
    color: theme.palette.bronze,
    '& $icon': {
      color: theme.palette.bronze
    },
    "& .MuiButton-label": {
      color: theme.palette.bronze
    }
  }
});

class LeftMenu extends React.Component {

  constructor(props) {
    super(props);
    const { classes } = props;

    this.icons = {
      projects: <StorefrontIcon className = { classes.icon } />,
      users: <PeopleIcon className = { classes.icon } />,
      pages: <InsertDriveFileIcon className = { classes.icon } />,
      downloadables: <CloudDownloadIcon className = { classes.icon } />,
      references: <CardTravelIcon className = { classes.icon }/>,
      developers: <BusinessIcon className = { classes.icon } />,
      countries: <LanguageIcon className = { classes.icon } />,
      help: <HelpIcon className = { classes.icon } />,
      mailer_readme: <EmailIcon className = { classes.icon } />,
      newsletter_emails: <EmailIcon className = { classes.icon } />,
      companies: <AccountBalanceIcon className = { classes.icon } />,
      statistics: <DashboardIcon className = { classes.icon } />
    }
    this.allowedPaths = {
      projects: [Routes.projectsList(), Routes.project()],
      users: [Routes.usersList(), Routes.user()],
      pages: [Routes.pagesList(), Routes.page()],
      downloadables: [Routes.downloadablesList(), Routes.downloadable()],
      developers: [Routes.developersList(), Routes.developer()],
      countries: [Routes.countriesList(), Routes.country()],
      mailer_readme: [Routes.mailerReadme()],
      newsletter_emails: [Routes.newsletterEmails()],
      companies: [Routes.companiesList(), Routes.company()],
      statistics: [Routes.statistics()]
    }

    this.state = {
      openedGroups: {

      }
    }

    this.onClickListItem = this.onClickListItem.bind(this);
  }

  onClickListItem(item) {
    const { openedGroups } = { ...this.state };
    openedGroups[item.name] = !Boolean(openedGroups[item.name]);
    this.setState({
      openedGroups: openedGroups
    })
  }

  componentDidMount() {
    LoadMenuItemsUseCase.execute()
    .then((result) => {
      const { data: { items: rawItems } } = result;
      let items = this.convertItems(rawItems);
      let openedGroups = this.openGroupsIfNeed(items);
      this.setState({
        items: items,
        openedGroups: openedGroups
      })
    });
  }

  convertItems(rawItems) {
    return rawItems.map((item) => {
      return {
        ...item,
        displayName: I18n.t(`menu.${item.name}`),
        icon: this.icons[item.name],
        url: item.items ? undefined : `/admin/${item.name}`,
        items: item.items ? this.convertItems(item.items) : undefined
      }
    })
  }

  openGroupsIfNeed(items, parentItem) {
    let openedGroups = {};
    items.forEach((item) => {
      if(item.items) {
        openedGroups = { ...this.openGroupsIfNeed(item.items, item) };
      }
      else {
        if(parentItem && this.itemMatched(item)) {
          openedGroups[parentItem.name] = true;
        }
      }
    })
    return openedGroups;
  }

  itemMatched(item) {
    let matched = false;
    (this.allowedPaths[item.name] || []).forEach((path) => {
      let match = matchPath(window.location.pathname, {
        path: path,
        exact: true,
        strict: false
      });
      if(match && match.isExact) {
        matched = true;
      }
    })
    return matched;
  }


  nestedList(parentItem) {
    const { classes } = this.props;
    const { openedGroups } = this.state;

    return <React.Fragment>
      <ListItem className = { classes.listItem }
                button
                onClick = { (event) => this.onClickListItem(parentItem) } >
        <ListItemIcon className = { classes.iconContainer} >
          { this.icons[parentItem.name] }
        </ListItemIcon>
        <ListItemText primary = { parentItem.displayName } className = { classes.textContainer }/>
        { openedGroups[parentItem.name] ? <ExpandLess /> : <ExpandMore /> }
      </ListItem>
      <Collapse in = { openedGroups[parentItem.name] }
                timeout = "auto"
                unmountOnExit>
        <List>
          {
            parentItem.items.map((item) => {
              return <React.Fragment key = { item.name } >
                {
                  item.url && this.link(item, true)
                }
              </React.Fragment>
            })
          }
        </List>
      </Collapse>
    </React.Fragment>
  }

  link(item, nested) {
    const { classes } = this.props;
    return <ListItem button
                     className = { clsx({
                      [classes.listItem]: true,
                      [classes.nestedListItem]: nested}) } >
      <NavLink activeClassName = { classes.activeLink }
               className = { classes.link }
               to = { item.url }
               isActive = { () => {
                 return this.itemMatched(item);
              }
            }>
        <ListItemIcon className = { classes.iconContainer} >
          { this.icons[item.name] }
        </ListItemIcon>
        <ListItemText primary = { item.displayName } className = { classes.textContainer } />
      </NavLink>
    </ListItem>
  }

  render() {
    const { classes } = this.props;
    const { items = [] } = this.state;

    return <Drawer anchor = { "left" }
                   classes = { { paper: classes.drawer } }
                   open = { true }
                   variant = { "persistent" } >
      <List className = { classes.listRoot } >
        {
          items.map((item) => {
            return <React.Fragment key = { item.name } >
              {
                item.url && this.link(item, false)
              }
              {
                item.items && this.nestedList(item)
              }
            </React.Fragment>
          })
        }
      </List>
    </Drawer>
  }
}


export default withStyles(styles)(LeftMenu);
